export default __webpack_public_path__ + "static/media/proximanova-regular.08d45952.ttf";